/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import Imgix from 'js/components/Imgix';

import { Typography2, breakpoints } from '@coursera/cds-core';

import ModuleLayout, { noImage } from 'bundles/cds-labs/components/Modules/ModuleLayout';
import { getRedesignPartnerLogos } from 'bundles/coursera-plus/components/constants';

import _t from 'i18n!nls/coursera-plus-landing-page';

const styles = {
  imageContainer: (numImages: number) => css`
    margin-top: var(--cds-spacing-300);
    display: grid;
    max-width: 100%;
    grid-template-columns: repeat(${numImages}, minmax(0, 1fr));
    gap: var(--cds-spacing-100);
    justify-content: center;
    align-items: center;

    ${breakpoints.down('sm')} {
      display: flex;
      flex-wrap: wrap;
      gap: var(--cds-spacing-200);
      align-items: start;
      justify-content: space-evenly;
    }

    ${breakpoints.down('xs')} {
      gap: 0;
    }

    img {
      width: 100%;

      ${breakpoints.down('sm')} {
        flex: 1;
        min-width: calc((100% - var(--cds-spacing-200)) / 4 - 8px);
        max-width: calc((100% - var(--cds-spacing-200)) / 4 - 8px);
      }
    }
  `,
};

const CourseraPlusPartnerLogos = () => {
  const tagline = _t('Learn from 350+ top universities and companies');
  const partners = getRedesignPartnerLogos().filter((partner) => Boolean(partner.logo?.url));
  const renderContent = () => (
    <React.Fragment>
      <Typography2 variant="titleSmall" component="h2" color="inherit">
        {tagline}
      </Typography2>
      <div css={styles.imageContainer(partners.length)}>
        {partners.map((partner) => {
          if (!partner.logo?.url) return null;
          return (
            <Imgix
              key={partner.id}
              src={partner.logo?.url}
              alt={partner.name ? _t('{partnerName} logo', { partnerName: partner.name }) : ''}
            />
          );
        })}
      </div>
    </React.Fragment>
  );

  return <ModuleLayout renderContent={renderContent} assembly={noImage({})} />;
};

export default CourseraPlusPartnerLogos;
